import React from 'react';

import { StyledAccordion } from './styles';

const CustomAccordion = props => <StyledAccordion {...props} />;

export default CustomAccordion;
